import { FormType } from '@cod-monorepo/interfaces';
import { StepConfig } from '../../../../shared/types/step-config.type';

export const LargeInstrumentWarehouseDiscrepancyStepConfig: StepConfig = {
    type: FormType.LARGE_INSTRUMENT_WAREHOUSE_DISCREPANCY
};
